import styled from 'styled-components/macro';

// import theme helpers
import { getFontWeight } from '../../../../util/theme';

// import base styled components
import { Error } from '../../styled';

const CtaBarError = styled(Error)`
  font-weight: ${getFontWeight('thin')};

  max-width: 185px;

  right: 5px;
`;

export default CtaBarError;
